import _extends from 'babel-runtime/helpers/extends';
/* eslint-disable react/prop-types */
/* This is the same as the side-nav-menu-item, product-menu-item, sub-nav-start-item, sub-nav-end-item renderers and is going to be replaced with a generic solution */
import React from 'react';
import { AdditionalNavItem } from '@sitebase/web-shell-kit/es/header-kit/additional-nav';
import { Drawer } from '@sitebase/web-shell-kit/es/header-kit/drawer';
import { DrawerItem } from '@sitebase/web-shell-kit/es/header-kit/drawer';
import IconAsset from '@sitebase/web-shell-kit/es/header-kit/IconAsset';

import { publish } from '../patched-message-bus';
import { eventRequested } from './message-bus-helpers';

var type = '@sitebase/sub-nav-end-item';

var preventLinkClickDefault = function preventLinkClickDefault(e) {
  return e && e.preventDefault();
};

var onClick = function onClick(event, data) {
  preventLinkClickDefault(event);
  publish(eventRequested(data));
};

var renderDrawer = function renderDrawer(items, runRenderer) {
  return React.createElement(
    Drawer,
    { 'data-test-id': type + '.drawer' },
    items.map(function (item, index) {
      if (item.type === type) {
        var _ref = item.data || {},
            id = _ref.id,
            label = _ref.label,
            icon = _ref.icon,
            _ref$link = _ref.link,
            link = _ref$link === undefined ? {} : _ref$link;

        var _item$children = item.children,
            children = _item$children === undefined ? [] : _item$children;

        return React.createElement(
          DrawerItem,
          _extends({
            id: id || label || index,
            'data-test-id': type + '.drawer.item' + (id ? '_' + id : ''),
            key: id || label || index
          }, link, {
            href: link.url,
            icon: icon ? React.createElement(IconAsset, { name: icon }) : null,
            onClick: children.length ? undefined : function (event) {
              return onClick(event, item.data);
            }
          }),
          label,
          children.length ? renderDrawer(children, runRenderer) : null
        );
      }
      return runRenderer(item);
    })
  );
};

export default {
  type: type,
  render: function render(_ref2, runRenderer) {
    var children = _ref2.children,
        data = _ref2.data;
    var id = data.id,
        label = data.label,
        icon = data.icon,
        _data$link = data.link,
        link = _data$link === undefined ? {} : _data$link;


    return React.createElement(
      AdditionalNavItem,
      _extends({
        key: id || label,
        'data-test-id': '' + type + (id ? '_' + id : ''),
        icon: icon ? React.createElement(IconAsset, { name: icon }) : undefined
      }, link, {
        href: link.url,
        label: label
      }),
      children.length ? renderDrawer(children, runRenderer) : null
    );
  }
};
//# sourceMappingURL=sub-nav-end-item.js.map